// extracted by mini-css-extract-plugin
export default {"table":"Table_table__ffFfZ","row":"Table_row__IFHnl","col":"Table_col__t2t4s","item":"Table_item__eg+w5","icon":"Table_icon__bu5yh","label":"Table_label__zKkKP"};